import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FileDown } from "lucide-react";
import { Input } from "@/components/ui/input";
import StandardFoodListTable from "./standar-food-list-table";
import Paginat from "@/components/lib/paginat";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";
import { TabsContent } from "@/components/ui/tabs";
import { useFilter } from "@/hooks/useFilter";
import { useSearch } from "@/hooks/useSearch";
import { usePagination } from "@/hooks/usePagination";
import { useSelector } from "react-redux";
import { useState } from "react";

function DraftListTabs() {
  const { standardFoods } = useSelector(
    (state) => state.menuManage.standardFood
  );
  const [filters, setFilters] = useState({
    status: "draft",
  });
  const [searchText, setSearchText] = useState("");
  const [perPage, setPerPage] = useState(10);
  const filteredData = useFilter(standardFoods, filters, 300);
  const searchData = useSearch(
    filteredData,
    searchText,
    ["item_no", "name", "description", "category_name"],
    300
  );
  const { paginatedData, paginationInfo, onPageChange } = usePagination(
    searchData,
    perPage
  );

  return (
    <TabsContent value="draft">
      <div className="mt-5">
        <div className="w-full flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
          <div className="w-[260px]">
            <div className="relative">
              <Search
                size={18}
                className="text-cwhite3 absolute top-2 left-2"
              />
              <Input
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search"
                className="bg-cblack3 pl-8"
              />
            </div>
          </div>
          <div className="flex flex-col  gap-1.5 justify-end items-end">
            <div className="flex gap-3 justify-center items-center">
              <Button
                className={"bg-cblack3 border border-gray-600 text-cwhite2"}
              >
                <FileDown size={18} /> Export
              </Button>
              <div className="flex gap-1 justify-center items-center">
                <h3 className="text-white">Show</h3>
                <Select
                  onValueChange={(value) => setPerPage(Number(value))}
                  value={perPage.toString()}
                >
                  <SelectTrigger className="w-[60px]">
                    <SelectValue placeholder="10" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem value="10">10</SelectItem>
                      <SelectItem value="20">20</SelectItem>
                      <SelectItem value="40">40</SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5">
          <StandardFoodListTable standardFoods={paginatedData} />
        </div>
        <div>
          <Paginat
            pagination={paginationInfo}
            onPageChange={onPageChange}
            className="mt-4"
          />
        </div>
      </div>
    </TabsContent>
  );
}

export default DraftListTabs;
